
import { defineComponent, ComputedRef, reactive, Ref, ref } from 'vue'

import { validateInfos } from 'ant-design-vue/lib/form/useForm'
import { Form,message } from 'ant-design-vue'
import useI18nAntdFormVaildateInfos from '@/composables/useI18nAntdFormVaildateInfos'
const useForm = Form.useForm;

import {FormDataType} from '../../data.d'


interface AddSkuSetupData {
    validateInfos: ComputedRef<validateInfos>;
    modelRef: FormDataType;
    typeStrt: Ref<string>;
    handleSubmit: (e: MouseEvent) => void;
    handleCtrl: (e: MouseEvent) => void;
    handleKeyClick: (val: any) => void;
}

export default defineComponent({
    name: 'AddSku',
    props: {
        typeStr: {
            type: String,
            default: ''
        },
        formdata: {
            type: Object,
            default: () => {return {}}
        }
    },
    emits: ['update:visible', 'formData'],
    setup(props,{emit}):AddSkuSetupData {
        const {formdata, typeStr} = props
        console.log('typestr', typeStr);
        console.log('formdata', formdata);
        let flag = typeStr == 'addNewlyAddedSku'
        let typeStrt = ref<string>(typeStr)
        const modelRef = reactive<FormDataType>({
            skuCode: flag ? '' : formdata.skuCode,
            hasBattery: flag ? null : formdata.hasBattery,
            declareNameCn: flag ? '' : formdata.declareNameCn,
            declareNameEn: flag ? '' : formdata.declareNameEn,
            skuNameCn: flag ? '' : formdata.skuNameCn,
            skuNameEn: flag ? '' : formdata.skuNameEn,
            declareValue: flag ? null : formdata.declareValue,
            declareOriginalCurrency: flag ? 'USD' : formdata.declareOriginalCurrency,
            declareWeight: flag ? null : formdata.declareWeight,
            hsCode: flag ? '' : formdata.hsCode,
            length: flag ? null : formdata.length,
            width: flag ? null : formdata.width,
            height: flag ? null : formdata.height,
            productBrand: flag ? '' : formdata.productBrand,
            material: flag ? '' : formdata.material,
            purpose: flag ? '' : formdata.purpose,
            declareUrl: flag ? '' : formdata.declareUrl,
            remarks: flag ? '' : formdata.remarks,
        })
        const rulesRef = reactive({
            skuCode: [{
                required: true,
                message: '请输入SKU编号'
            }],
            hasBattery: [{
                required: true,
                message: '请选择商品属性'
            }],
            declareNameCn: [{
                required: true,
                message: '请输入申报中文品名'
            }],
            declareNameEn: [{
                required: true,
                message: '请输入申报英文品名'
            }],
            skuNameCn: [],
            skuNameEn: [],
            declareValue: [{
                required: true,
                message: '请输入申报价值'
            }],
            declareCurrency: [{
                required: true,
                message: '请选择申报币种'
            }],
            declareWeight: [{
                required: true,
                message: '请输入申报重量'
            }],
            hsCode: [],
            length: [{
                required: true,
                validator: (rule:any,value:string,callback:any) => {
                    if(value==''||value==undefined){
                        return Promise.reject('请输入长度')
                    }else if(parseInt(value) <=0  ){
                        return Promise.reject('只能输入大于0的整数')
                    }else{
                        return Promise.resolve()
                    }
                }
            }],
            width: [{
                required: true,
                validator: (rule:any,value:string,callback:any) => {
                    if(value==''||value==undefined){
                        return Promise.reject('请输入宽度')
                    }else if(parseInt(value) <=0  ){
                        return Promise.reject('只能输入大于0的整数')
                    }else{
                        return Promise.resolve()
                    }
                }
            }],
            height: [{
                required: true,
                validator: (rule:any,value:string,callback:any) => {
                    if(value==''||value==undefined){
                        return Promise.reject('请输入高度')
                    }else if(parseInt(value) <=0  ){
                        return Promise.reject('只能输入大于0的整数')
                    }else{
                        return Promise.resolve()
                    }
                }
            }],
            productBrand: [],
            material: [],
            purpose: [],
            declareUrl: [],
            remarks: [],
        })
        const { validate, validateInfos } = useForm(modelRef, rulesRef)
        const validateInfosNew = useI18nAntdFormVaildateInfos(validateInfos)
        const handleSubmit = async(e: MouseEvent) => {
            const fieldsValue = await validate<FormDataType>()
            const formvalue = {fieldsValue,type: props.typeStr}
            if(fieldsValue.hsCode&&fieldsValue.hsCode.length>0&&(fieldsValue.hsCode.length<6||fieldsValue.hsCode.length>10)){
                message.warning('海关编码长度范围在6~10位数字')
            }else if( fieldsValue.declareUrl == '' && fieldsValue.hsCode == ''){
                message.warning('温馨提示：商品链接或者海关编码用于品名归类，出口报关及进口清关，请您至少填写其中一项。')
                return false
            }else{
                emit('formData', formvalue)
            }
        }
        const handleCtrl = (e:MouseEvent) => {
            emit('update:visible', false)
        }
        const handleKeyClick = (val:any) => {
            val.target.value = val.target.value.replace(/[^\d]/g,'')
        }
        return {
            modelRef,
            validateInfos: validateInfosNew,
            typeStrt,
            handleSubmit,
            handleCtrl,
            handleKeyClick
        }
    }
})
